// app/javascript/controllers/bulk_select_controller.js
import { Controller } from "@hotwired/stimulus"

// data-controller="bulk-select"
export default class extends Controller {
  static targets = ["checkbox", "selectAll", "bulkActions", "count"]

  connect() {
    this.updateBulkActions()
  }

  // Clique sur "select all"
  toggleAll() {
    if (!this.hasSelectAllTarget) return

    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
    this.updateBulkActions()
  }

  // Clique sur une checkbox de ligne
  toggle() {
    this.updateSelectAll()
    this.updateBulkActions()
  }

  updateSelectAll() {
    if (!this.hasSelectAllTarget || this.checkboxTargets.length === 0) return

    const allChecked  = this.checkboxTargets.every(cb => cb.checked)
    const someChecked = this.checkboxTargets.some(cb => cb.checked)

    this.selectAllTarget.checked = allChecked
    this.selectAllTarget.indeterminate = someChecked && !allChecked
  }

  updateBulkActions() {
    if (!this.hasBulkActionsTarget || !this.hasCountTarget) return

    const selectedCount = this.selectedCheckboxes.length

    if (selectedCount > 0) {
      this.bulkActionsTarget.classList.remove("hidden")
      this.countTarget.textContent = selectedCount
    } else {
      this.bulkActionsTarget.classList.add("hidden")
      this.countTarget.textContent = 0
    }
  }

  get selectedCheckboxes() {
    return this.checkboxTargets.filter(cb => cb.checked)
  }

  // Ajoute les IDs sélectionnés au form avant submit (bulk archive)
  addHiddenInputs(event) {
    const form = event.currentTarget.form || event.currentTarget.closest("form")
    if (!form) return

    // Nettoyer les anciens inputs
    form.querySelectorAll('input[name="purchase_ids[]"]').forEach(input => input.remove())

    // Ajouter les nouveaux
    this.selectedCheckboxes.forEach(checkbox => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "purchase_ids[]"
      input.value = checkbox.value
      form.appendChild(input)
    })
  }
}
